import LoginService from "..";

const fields = {
  phone: 'loginName',
  validateCode: 'userPassword',
}

export const mobile = new LoginService({
  url: '/api/user/v1/user/authLogin',
  fields,
});
